<template>
    <b-overlay :show="loading" class="animated">
        <div class="animated">
            <v-server-table
                :columns="table_config.columns"
                :options="table_config.options"
                :theme="theme"
                :ref="ref"
                @onUpdate="onUpdate"
            >
                <span slot="name" slot-scope="{ row }">
                    <a :href="`#/quality-control/${row.id}`" class="btn-link">{{ row.name }}</a>
                </span>
                <span slot="sample_type" slot-scope="{ row }">
                    {{ row.test_package.sample_type.name }}
                </span>
                <span slot="schedulable_task_type" slot-scope="{ row }">
                    {{formatTaskName(row.schedulable_task_type) }}
                </span>
                <span slot="task" slot-scope="{ row }">
                    {{ row.test_package.name }}
                </span>
            </v-server-table>
        </div>
    </b-overlay>
</template>
<script>
import Vue from "vue";
import BaseServerTable from "@/components/shared/BaseServerTable";
import { ServerTable } from "vue-tables-2";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { AccessControlCheck } from "@/auth/AccessControlCheck";
import { formatModelPath, stripTaskFromName } from "@/shared/utils";
import QualityControlCollection from "@/collections/lab/QualityControlCollection";
    
Vue.use(ServerTable)

export default {
    name: "QualityControlRelatedListTable",
    extends: BaseServerTable,
    mixins: [ToastNotifications],
    components: {
        ServerTable
    },
    props: {
        collection: {
            type: Object,
            default: () => new QualityControlCollection()
        },
        task: {
            type: String,
            default: () => ""
        },
        quality_control: {
            type: Object,
            default: () => null,
        },
        show_columns: {
            type: Array,
            default: () => [
                "name",
                "sheet_label",
                "sample_type",
                "schedulable_task_type",
                "task",
                "interval",
                "interval_index",
            ]
        },
        filterable: {
          type: Array,
          default: () => [],
        },
        sortable: {
          type: Array,
          default: () => [],
        },
        show_filters: {
          type: Boolean,
          default: false,
        },
    },
    data() {
        return {
            entity_type: "qualityControl",
            sample_type: [],
            table_config: Object.assign(this.getDefaultTableConfig(), {
                options: {
                    headings: {
                        schedulable_task_type: "Task type"
                    },
                    filterable: this.filterable,
                    sortable: this.sortable,
                    debounce: 300,
                },
            }),
        };
    },
    methods: {
        prepareCollectionFilter(filter) {
            //filter.sortAddDesc("created_at", true);

            filter.filterEquals("schedulable_task_id", this.task);

            filter.connectionAdd(['testPackage.sampleType']);

            return filter;
        },
        formatTaskName(str) {
            return stripTaskFromName(formatModelPath(str))
        },
        checkPermission(permission) {
            return AccessControlCheck.checkPermission(permission);
        },
        onUpdate() {
            this.$refs[this.ref].refresh();
        },
    },
};
</script>